/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_Failed_TitleInputs */



/**
* | output |
* | --- |
* | "The recording failed" |
*
* @param {Meeting_Notetaker_Issue_Failed_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_failed_title = /** @type {((inputs?: Meeting_Notetaker_Issue_Failed_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Failed_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De opname is mislukt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'enregistrement a échoué")
	return /** @type {LocalizedString} */ ("The recording failed")
});